export default __webpack_public_path__ + "static/media/mesclasse.183dd2a6.svg";